export const CACHE_KEYS = {
  USER_ENTITLEMENTS: 'tyk_ai_studio_admin_userEntitlements',
  FEATURES: 'tyk_ai_studio_admin_features',
  CONFIG: 'tyk_ai_studio_admin_config',
  SSO_NOTIFICATION: 'tyk_ai_studio_admin_sso_notification',
  GROUP_NOTIFICATION: 'tyk_ai_studio_admin_group_notification',
  LICENSE_DAYS_LEFT: 'tyk_ai_studio_admin_license_days_left',
  RBAC_CATALOGUE: 'tyk_ai_studio_admin_rbac_catalogue'
};